import { useHMSLocalSignal } from "../hms";
import { useLivekitLocalSignal } from "../livekit";
import type { ProviderLocalSignal } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderLocalSignal = (): ProviderLocalSignal =>
  useProviderHook({
    hms: useHMSLocalSignal,
    livekit: useLivekitLocalSignal,
  })();
